<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<div class="card-header">
					<el-form :inline="true" :model="formInline" class="demo-form-inline" ref="searchform">
						<el-form-item :label="$t('index.username')" prop="name">
							<el-input :placeholder="$t('index.username')" v-model="formInline.name"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button @click="seachFun" type="primary">{{ $t('device.inquire') }}</el-button>
							<el-button @click="resetFun" type="primary">{{ $t('device.reset') }}</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-button @click="addUser" type="primary" v-if="$store.state.pageAction.indexOf('device.add')> -1">
					{{ $t('device.add') }}
				</el-button>
			</template>
			<el-table :data="appData" :default-sort="{prop: 'date', order: 'descending'}" border stripe
				style="width: 100%">
				<el-table-column :label="$t('order.account')" prop="account"></el-table-column>
				<el-table-column :label="$t('user.source')" prop="source"></el-table-column>
				<el-table-column :label="$t('role.group')" prop="role_title"></el-table-column>
				<el-table-column :label="$t('device.vesting')" prop="client_name"></el-table-column>
				<el-table-column :label="$t('order.status')" prop="status_title"></el-table-column>
				<el-table-column label="短信状态" width="100">
					<template #default="scope">
						<el-button @click="toggleSmsStatus(scope.row)" :type="scope.row.sms_status === 1 ? 'warning' : 'success'" size="small">
							{{ scope.row.sms_status === 1 ? '禁用' : '启用' }}
						</el-button>
					</template>
				</el-table-column>
				<el-table-column label="短信有效期" prop="sms_valid" width="120"></el-table-column>
				<el-table-column label="短信次数" prop="sms_num" width="100"></el-table-column>
				<el-table-column label="呼叫状态" width="100">
					<template #default="scope">
						<el-button @click="toggleCallStatus(scope.row)" :type="scope.row.call_status === 1 ? 'warning' : 'success'" size="small">
							{{ scope.row.call_status === 1 ? '禁用' : '启用' }}
						</el-button>
					</template>
				</el-table-column>
				<el-table-column label="呼叫有效期" prop="call_valid" width="120"></el-table-column>
				<el-table-column label="呼叫次数" prop="call_num" width="100"></el-table-column>
				<el-table-column :label="$t('role.timezone')" prop="timezone"></el-table-column>
				<el-table-column :label="$t('device.creation_time')" prop="create_at" width="160"></el-table-column>
				<el-table-column :label="$t('device.operating')" width="380">
					<template #default="scope">
						<el-button @click="handleEdit(scope.row)" type="primary" size="small"
							v-if="$store.state.pageAction.indexOf('device.edit')> -1">{{ $t('device.edit') }}
						</el-button>
						<el-button @click="handleSetting(scope.row)" type="warning" size="small">
							短信呼叫
						</el-button>
						<el-button @click="handleStatus(scope.row)" :type="scope.row.status === 1 ?'warning':'success'"
							size="small" v-if="$store.state.pageAction.indexOf('device.status')> -1">
							{{ scope.row.status === 1 ? $t('role.disable') : $t('role.enable') }}
						</el-button>
						<el-button @click="resetCode(scope.row)" type="info" size="small"
							v-if="$store.state.pageAction.indexOf('role.reset')> -1">{{ $t('role.reset') }}
						</el-button>
						<el-button @click="handleDelete(scope.row.uid)" type="danger" size="small"
							v-if="$store.state.pageAction.indexOf('device.delete')> -1">{{ $t('device.delete') }}
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog center :title="$t('role.add')" top="30vh" v-model="addPop" width="30%">
				<el-form :model="addForm" ref="addForm" :rules="rules">
					<el-form-item :label="$t('order.account')" label-width="120px" prop="account">
						<el-input v-model="addForm.account"></el-input>
					</el-form-item>
					<!--          <el-form-item :label="$t('role.phone')" label-width="120px" prop="mobile">-->
					<!--            <el-input v-model="addForm.mobile"></el-input>-->
					<!--          </el-form-item>-->
					<el-form-item :label="$t('login.password')" label-width="120px" prop="password"
						v-if="addForm.uid==''">
						<el-input v-model="addForm.password"></el-input>
					</el-form-item>
					<el-form-item :label="$t('device.vesting')" label-width="120px" prop="client_id">
						<el-cascader :options="clientOpts" :placeholder="$t('device.vesting')"
							v-model="addForm.client_id"></el-cascader>
					</el-form-item>
					<el-form-item :label="$t('role.group')" label-width="120px" prop="role_id">
						<el-select :placeholder="$t('role.group')" v-model="addForm.role_id">
							<el-option :key="item.value" :label="item.label" :value="item.value"
								v-for="item in roleOpts">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('role.timezone')" label-width="120px" prop="timezone">
						<el-select :placeholder="$t('role.timezone')" v-model="addForm.timezone">
							<el-option :key="item.value" :label="`${item.label} (${item.value})`" :value="item.value"
								v-for="item in timezoneOpts">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('order.status')" label-width="120px" prop="status">
						<el-radio :label="1" v-model="addForm.status">{{ $t('role.enable') }}</el-radio>
						<el-radio :label="2" v-model="addForm.status">{{ $t('role.disable') }}</el-radio>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="addPop = false">{{ $t('device.cancel') }}</el-button>
						<el-button @click="handleSubmit" type="primary">{{ $t('device.confirm') }}</el-button>
					</span>
				</template>
			</el-dialog>
			<el-dialog :center="true" :title="$t('role.change')" top="30vh" v-model="dialogFormVisible" width="30%">
				<el-form :model="resetform">
					<el-form-item :required="true" :label="$t('order.account')" label-width="80px">
						<el-input autocomplete="off" :disabled="true" v-model="resetform.name"></el-input>
					</el-form-item>
					<el-form-item :required="true" :label="$t('login.password')" label-width="80px">
						<el-input autocomplete="off" v-model="resetform.password"></el-input>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="dialogFormVisible = false">{{ $t('device.cancel') }}</el-button>
						<el-button @click="affirmReset" type="primary">{{ $t('device.confirm') }}</el-button>
					</span>
				</template>
			</el-dialog>
			<el-dialog :center="true" title="短信呼叫设置" top="30vh" v-model="settingDialogVisible" width="40%">
				<el-form :model="settingForm" label-width="120px">
					<el-form-item label="用户">
						<el-input autocomplete="off" :disabled="true" v-model="settingForm.name"></el-input>
					</el-form-item>
					<el-form-item label="短信状态">
						<el-button @click="settingForm.sms_status = settingForm.sms_status === 1 ? 2 : 1"
							:type="settingForm.sms_status === 1 ? 'warning' : 'success'" size="small">
							{{ settingForm.sms_status === 1 ? '禁用' : '启用' }}
						</el-button>
					</el-form-item>
					<el-form-item label="短信有效期">
						<el-date-picker v-model="settingForm.sms_valid" type="date" placeholder="选择日期"
							format="YYYY-MM-DD" value-format="YYYY-MM-DD">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="短信次数">
						<el-input v-model.number="settingForm.sms_num" type="number" min="0"></el-input>
					</el-form-item>
					<el-form-item label="呼叫状态">
						<el-button @click="settingForm.call_status = settingForm.call_status === 1 ? 2 : 1"
							:type="settingForm.call_status === 1 ? 'warning' : 'success'" size="small">
							{{ settingForm.call_status === 1 ? '禁用' : '启用' }}
						</el-button>
					</el-form-item>
					<el-form-item label="呼叫有效期">
						<el-date-picker v-model="settingForm.call_valid" type="date" placeholder="选择日期"
							format="YYYY-MM-DD" value-format="YYYY-MM-DD">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="呼叫次数">
						<el-input v-model.number="settingForm.call_num" type="number" min="0"></el-input>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="settingForm.remark" type="textarea" rows="3" placeholder="输入备注信息"></el-input>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="settingDialogVisible = false">{{ $t('device.cancel') }}</el-button>
						<el-button @click="handleSettingSubmit" type="primary">{{ $t('device.confirm') }}</el-button>
					</span>
				</template>
			</el-dialog>
			<el-pagination :page-size="formInline.size" :page-sizes="[10, 20, 50]" :total="listCount"
				@current-change="handleCurrentChange" @size-change="handleSizeChange" fixed="right"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>
		</el-card>
	</div>
</template>
<script>
	import system from "../../model/system";
	import role from "../../model/role";
	import client from "../../model/client";

	export default {
		name: "user",
		data() {
			return {
				dialogFormVisible: false,
				settingDialogVisible: false,
				settingForm: {
					uid: "",
					name: "",
					sms_status: 2,
					sms_valid: "",
					sms_num: 0,
					call_status: 2,
					call_valid: "",
					call_num: 0,
					remark: ""
				},
				timezoneOpts: [
					{
						"label": "UTC-12:00",
						"value": "Etc/GMT+12"
					},

					{
						"label": "UTC-11:00",
						"value": "Pacific/Midway"
					},

					{
						"label": "UTC-10:00",
						"value": "Pacific/Honolulu"
					},

					{
						"label": "UTC-09:00",
						"value": "America/Anchorage"
					},

					{
						"label": "UTC-08:00",
						"value": "America/Los_Angeles"
					},

					{
						"label": "UTC-07:00",
						"value": "America/Denver"
					},

					{
						"label": "UTC-06:00",
						"value": "America/Chicago"
					},

					{
						"label": "UTC-05:00",
						"value": "America/New_York"
					},

					{
						"label": "UTC-04:00",
						"value": "America/Caracas"
					},

					{
						"label": "UTC-03:00",
						"value": "America/Sao_Paulo"
					},

					{
						"label": "UTC-02:00",
						"value": "America/Noronha"
					},

					{
						"label": "UTC-01:00",
						"value": "Atlantic/Azores"
					},

					{
						"label": "UTC±00:00",
						"value": "Europe/London"
					},

					{
						"label": "UTC+01:00",
						"value": "Europe/Paris"
					},

					{
						"label": "UTC+02:00",
						"value": "Europe/Athens"
					},

					{
						"label": "UTC+03:00",
						"value": "Europe/Moscow"
					},

					{
						"label": "UTC+04:00",
						"value": "Asia/Dubai"
					},

					{
						"label": "UTC+05:00",
						"value": "Asia/Karachi"
					},

					{
						"label": "UTC+06:00",
						"value": "Asia/Dhaka"
					},

					{
						"label": "UTC+07:00",
						"value": "Asia/Bangkok"
					},

					{
						"label": "UTC+08:00",
						"value": "Asia/Shanghai"
					},

					{
						"label": "UTC+09:00",
						"value": "Asia/Tokyo"
					},

					{
						"label": "UTC+10:00",
						"value": "Australia/Sydney"
					},

					{
						"label": "UTC+11:00",
						"value": "Pacific/Guadalcanal"
					},

					{
						"label": "UTC+12:00",
						"value": "Pacific/Auckland"
					}
				],
				formInline: {
					name: "",
					page: 1,
					size: 10
				},
				resetform: {
					uid: "",
					name: "",
					password: ""
				},
				listCount: 0,
				appData: [],
				addPop: false,
				addForm: {
					uid: "",
					name: "",
					account: "",
					mobile: "",
					password: "",
					client_id: [],
					role_id: "",
					status: 1,
					timezone: ""
				},
				roleOpts: [],
				clientOpts: [],
				rules: {
					account: [{
							required: true,
							message: this.$t('login.user_empty'),
							trigger: "blur"
						},
						{
							min: 3,
							max: 10,
							message: this.$t('login.user_length'),
							trigger: "blur"
						}
					],
					client_id: [{
						required: true,
						message: this.$t('role.select_customer'),
						trigger: "blur"
					}],
					role_id: [{
						required: true,
						message: this.$t('role.select_group'),
						trigger: "blur"
					}],
					timezone: [{
						required: false,
						message: this.$t('role.select_group'),
						trigger: "blur"
					}]
				}
			};
		},
		async mounted() {
			await this.loadData();
			this.loadRole();
			this.loadClient();
		},
		methods: {
			async loadData() {
				const ret = await system.user(this.formInline)
				if (ret.code === 200) {
					this.appData = ret.data.list;
					this.listCount = ret.data.count;
				}
			},
			async loadRole() {
				const ret = await role.map({})
				if (ret.code === 200) {
					ret.data.forEach(v => {
						this.roleOpts.push({
							value: v.id,
							label: v.title
						})
					})
				}
			},
			async loadClient() {
				const ret = await client.list({});
				if (ret.code === 200) {
					ret.data.forEach(i => {
						let options = {
							value: i.id,
							label: i.name,
							children: []
						};
						if (i.children.length > 0) {
							this.clientOpts.push({
								value: i.id,
								label: i.name
							});
							i.children.forEach(v => {
								let opts = {
									value: v.id,
									label: v.name
								};
								if (v.children.length > 0) {
									options.children.push({
										value: v.id,
										label: v.name
									});
									opts.children = [];
									v.children.forEach(item => {
										let children = {
											value: item.id,
											label: item.name,
										};
										if (item.children.length > 0) {
											children.children = [];
											item.children.forEach(val => {
												children.children.push({
													value: val.id,
													label: val.name
												});
											})
										}
										opts.children.push(children);
									});
								}
								options.children.push(opts);
							});
						}
						this.clientOpts.push(options);
					});
				}
			},
			async handleSubmit() {
				this.$refs.addForm.validate(async valid => {
					if (valid) {
						const params = JSON.parse(JSON.stringify(this.addForm))
						params.name = params.account
						params.client_id = params.client_id.pop()
						const ret = await system.operate(params)
						if (ret.code === 200) {
							this.addPop = false
							this.$message.success(ret.message)
							this.loadData()
						} else {
							this.$message.warning(ret.message)
						}
					} else {
						return false;
					}
				});
			},
			async handleStatus(row) {
				const ret = await system.status({
					uid: row.uid,
					status: row.status == 1 ? 2 : 1
				})
				if (ret.code === 200) {
					this.$message.success(ret.message)
					this.loadData()
				} else {
					this.$message.warning(ret.message)
				}
			},
			resetCode(row) {
				this.dialogFormVisible = true;
				this.resetform.uid = row.uid;
				this.resetform.name = row.name;
			},
			async affirmReset() {
				const ret = await system.reset(this.resetform);
				if (ret.code === 200) {
					this.$message.success(ret.message);
					this.dialogFormVisible = false;
				} else {
					this.$message.error(ret.message);
				}
			},
			seachFun() {
				this.loadData();
			},
			resetFun() {
				this.formInline.name = ''
				this.loadData();
			},
			addUser() {
				this.addPop = true;

				this.$refs.addForm.resetFields()
				this.addForm = {
					uid: "",
					name: "",
					account: "",
					password: "",
					client_id: "",
					role_id: "",
					status: 1,
					timezone: ""
				}
			},
			handleDelete(uid) {
				this.$confirm(this.$t('device.delete_note'), this.$t('device.tip'), {
						confirmButtonText: this.$t('device.confirm'),
						cancelButtonText: this.$t('device.cancel'),
						type: "warning"
					})
					.then(async () => {
						const ret = await system.delete({
							uid: uid
						});
						if (ret.code === 200) {
							this.$message.success(this.$t('device.delete_success'));
							this.loadData();
						} else {
							this.$message.error(ret.message);
						}
					})
					.catch(() => {});
			},
			handleEdit(row) {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					this.addForm = JSON.parse(JSON.stringify(row))
					this.clientOpts.forEach(v => {
						if (this.addForm.client_id == v.value) {
							this.addForm.client_id = [v.value]
							return
						}
						if (v.children) {
							v.children.forEach(i => {
								if (this.addForm.client_id == i.value) {
									this.addForm.client_id = [v.value, i.value]
									return
								}
								if (i.children) {
									i.children.forEach(val => {
										if (this.addForm.client_id == val.value) {
											this.addForm.client_id = [v.value, i.value, val
												.value
											]
											return
										}
									})
								}
							})
						}
					})
				})
			},
			handleSizeChange(val) {
				this.formInline.size = val;
				this.loadData();
			},
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.loadData();
			},
			handleSetting(row) {
				this.settingDialogVisible = true;
				this.settingForm = {
					uid: row.uid,
					name: row.name,
					sms_status: row.sms_status || 2,
					sms_valid: row.sms_valid || "",
					sms_num: row.sms_num || 0,
					call_status: row.call_status || 2,
					call_valid: row.call_valid || "",
					call_num: row.call_num || 0,
					remark: ""
				}
			},
			async handleSettingSubmit() {
				const params = JSON.parse(JSON.stringify(this.settingForm));
				const ret = await system.setting(params);
				if (ret.code === 200) {
					this.$message.success(ret.message);
					this.settingDialogVisible = false;
					this.loadData();
				} else {
					this.$message.warning(ret.message);
				}
			},
			async toggleSmsStatus(row) {
				const ret = await system.setting({
					uid: row.uid,
					sms_status: row.sms_status === 1 ? 2 : 1
				});
				if (ret.code === 200) {
					this.$message.success(ret.message);
					this.loadData();
				} else {
					this.$message.warning(ret.message);
				}
			},
			async toggleCallStatus(row) {
				const ret = await system.setting({
					uid: row.uid,
					call_status: row.call_status === 1 ? 2 : 1
				});
				if (ret.code === 200) {
					this.$message.success(ret.message);
					this.loadData();
				} else {
					this.$message.warning(ret.message);
				}
			}
		}
	};
</script>
<style scoped>
	.demo-form-inline {
		margin-top: 20px;
	}

	.card-header {
		display: flex;
		align-items: center;
	}

	.el-pagination {
		margin: 30px 0px;
		float: right;
	}
</style>